import React from 'react'


function EmbeddedSite({link, scroll}) {
  return (
    <iframe 
      src={link}
      title="Site Launcher"
      width="90%"
      height="500px"
      className='rounded-lg border-4 border-gray-300 shadow-[0_-2px_8px_1px_rgba(255,0,255,0.2)]'
      sandbox="allow-scripts allow-same-origin"
      scrolling={scroll}
      
    />
  );
}

function MyButton({link}) {

    return (
        <a href={link} target = "_blank" rel="noopener noreferrer"> {/*"remove targe and rel to keep it in the same page"*/}
            <button className="border-4 border-gray-300 text-gray-100 [background-color:#010101] hover:bg-gray-600 px-4 py-3 rounded-full justify-center font-bold">
                Launch Website
            </button>
        </a>
    );
}

const CancerResearch = () => {
  return (
    <div className='mt-10'>
       <div className="flex flex-col items-center justify-center w-full lg:w-1/2 mx-auto gap-y-3">
                <p className="font-bold">AIM3 Lung Cancer Research Website:</p>
                <EmbeddedSite link="https://aim-3-zeta.vercel.app/" scroll='yes' />
                <MyButton link="https://aim-3-zeta.vercel.app/" />
        </div>
    </div>
  )
}

export default CancerResearch
